<template>
    <div class="white-box plan-selection__plan text-black">
        <ul class="choose-plan">
            <li class="choose-plan__item" v-if="cardTitle">
                <span class="choose-plan__item--paymentType">
                    <p class="label_text d-block">Name</p>
                    <p class = "item_text">{{getCardTitle()}}</p>
                </span>
                <span class="choose-plan__item--text">
                    <v-icon class = "check_color material-icons-round">
                        check_circle
                    </v-icon>
                </span>
            </li>
            <li class="choose-plan__item" v-for="(item, index) in cardContent" :key="index">
                <span class="choose-plan__item--paymentType">
                    <p class="label_text d-block">{{item.label}}</p>
                    <p class = "item_text">{{getItemValue(item.value)}}</p>
                </span>
                <span class="choose-plan__item--text">
                    <v-icon class = "check_color material-icons-round" v-if="getItemValue(item.value)">
                        check_circle
                    </v-icon>
                    <v-icon class = "cross_color material-icons-round" v-else>
                        cancel
                    </v-icon>
                </span>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'Detail-Card',
    props: {
        cardTitle: String,
        cardDescription: String,
        cardContent: Array
    },
    methods: {
        getCardTitle () {
            if (this.cardTitle === 'undefined') {
                return null
            }
            return this.cardTitle
        },
        getItemValue (value) {
            if (value === 'undefined') {
                return null
            }
            return value
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/components/dashboard/dashboard.scss";

.center {
    justify-content: center;
}

.choose-plan__item--title {
    font-size: $font-size-xs;
    font-weight: $font-weight-medium;
    // flex: 0 0 120px;

    @media (min-width: 992px) {
        font-size: $font-size-base;
    }
}
.check_color {
    color: #3F7E44 !important;
}
.label_text {
    margin-bottom: 2px !important;
    font-weight: 600;
    font-size: 16px;
    color: #000000;
}
.item_text {
    margin-bottom: 2px !important;
    font-weight: 400;
    font-size: 14px;
    color: #232323;
}
.cross_color {
    color: #8c8c8c !important
}
</style>
